import { render, staticRenderFns } from "./copyOrderPerson.vue?vue&type=template&id=34696602"
import script from "./copyOrderPerson.vue?vue&type=script&lang=js"
export * from "./copyOrderPerson.vue?vue&type=script&lang=js"
import style0 from "./copyOrderPerson.vue?vue&type=style&index=0&id=34696602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports